import { SimpleDateFilter as AntdSimpleDateFilter } from "@empglabs/backoffice-ui-kit"

const SimpleDateFilter = props => {
  return <AntdSimpleDateFilter {...props} />
}

export default SimpleDateFilter
